'use strict';

(function ($, MIKI_HD) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	var corporateMap = function corporateMap() {
		var googleCliKey = 'gme-parismikiinc';
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = '//maps.googleapis.com/maps/api/js?client=' + googleCliKey + '&v=quarterly&libraries=geometry';
		script.id = 'googleApiScript';

		script.onload = function () {
			var mapLatLng = new google.maps.LatLng({ lat: 35.6301927, lng: 139.745488 });
			var canvas = document.getElementById('map-canvas');
			var styles = [{
				stylers: [{ saturation: -50 }]
			}, {
				'featureType': 'landscape',
				'elementType': 'geometry.fill',
				'stylers': [{ 'color': '#efefe4' }]
			}, {
				'featureType': 'water',
				'stylers': [{ 'color': '#bbc1d7' }]
			}];
			var map = new google.maps.Map(canvas, {
				center: mapLatLng,
				zoom: 17,
				styles: styles,
				mapTypeControl: false,
				fullscreenControl: false,
				streetViewControl: false
			});
			var marker = new google.maps.Marker({
				position: mapLatLng,
				map: map,
				icon: new google.maps.MarkerImage('/hd/images/about/profile/map_marker.png')
			});
		};
		document.body.appendChild(script);
	};

	if (MIKI_HD.va.pathname === '/hd/about/profile.html' || MIKI_HD.va.pathname === '/hd/eng/about/profile.html') {
		corporateMap();
	}
})(window.jQuery, window.MIKI_HD);